export const CASE_STATUS_ID_MAP = {
  OPEN: 101,
  COMPLIANT: 102,
  "NON-COMPLIANT": 103,
  APPROVED: 104,
  REJECTED: 105,
  "ON-HOLD": 106,
  EXCEPTION: 107,
  "NON-AFR": 108,
  "OPEN-REOPENED": 109,
  "COMPLIANT-REOPENED": 110,
  "NON-COMPLIANT-REOPENED": 111,
  "APPROVED-REOPENED": 112,
  "REJECTED-REOPENED": 113,
  "EXCEPTION-REOPENED": 114,
  "ON-HOLD-REOPENED": 115,
  "NON-AFR-REOPENED": 116,

  // Legacy key aliases kept for backward compatibility.
  "OPEN-Reopened": 109,
  "COMPLIANT-Reopened": 110,
  "NON-COMPLIANT-Reopened": 111,
  "APPROVED-Reopened": 112,
  "REJECTED-Reopened": 113,
  "EXCEPTION-Reopened": 114,
  "ON-HOLD-Reopened": 115,
  "NON-AFR-Reopened": 116,
};

export const CASE_REJECT_REASON_OPTIONS = [
  "Invalid Status",
  "Invalid BL",
  "Pre requisite task open",
  "Bank account mismatch",
  "PoP unavailable",
  "Short payment",
  "Invalid Date",
  "Amount Unavailable",
  "Exceeding Approval limit",
  "Other",
];
